// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mzeQ","footer":"styles_footer__Z_rGk"};